// extracted by mini-css-extract-plugin
export default {"highlightedText":"highlighted-text-module__highlightedText__t1vDR6P"};